import { string } from "yup";

export const middleName = () =>
  string()
    .test(
      "not-empty",
      "Middle name contains only whitespaces",
      (field) => !field || field.trim().length > 0
    )
    .test(
      "not-allowed-characters",
      "Middle name contains character that is not allowed",
      (field) => !field || /^[a-zA-ZÀ-ÿ\s-.'0-9]+$/.test(field ?? "")
    )
    .test(
      "not-allowed-multiple-spaces",
      "Middle name cannot have leading or trailing spaces",
      (field) => !field || !/\s{2,}/.test(field)
    )
    .trim("Middle name cannot have leading or trailing spaces")
    .strict(true);

export const firstName = () =>
  string()
    .required("First name is required")
    .test(
      "not-empty",
      "First name cannot be empty",
      (field) => !field || field.trim().length > 0
    )
    .test(
      "not-allowed-&",
      'If you want to add an additional person, use the "Add someone else to the policy" option',
      (field) => (field ? field.indexOf("&") === -1 : true)
    )
    .test(
      "not-allowed-characters",
      "First name contains character that is not allowed",
      (field) => /^[a-zA-ZÀ-ÿ\s-.'0-9]+$/.test(field ?? "")
    )
    .test(
      "not-allowed-multiple-spaces",
      "First name cannot have leading or trailing spaces",
      (field) => !field || !/\s{2,}/.test(field)
    )
    .trim("First name cannot have leading or trailing spaces")
    .strict(true);

export const lastName = () =>
  string()
    .required("Last name is required")
    .test(
      "not-empty",
      "Last name cannot be empty",
      (field) => !field || field.trim().length > 0
    )
    .test(
      "not-allowed-characters",
      "Last name contains character that is not allowed",
      (field) => /^[a-zA-ZÀ-ÿ\s-.'0-9]+$/.test(field ?? "")
    )
    .test(
      "not-allowed-multiple-spaces",
      "Last name cannot have leading or trailing spaces",
      (field) => !field || !/\s{2,}/.test(field)
    )
    .trim("Last name cannot have leading or trailing spaces")
    .strict(true);
